import type { TranslationModule } from '../types';

export const sidebarTranslations: TranslationModule = {
  ro: {
    filters: "Filtre",
    clearAll: "Șterge tot",
    noFiltersAvailable: "Efectuați o căutare pentru a vedea filtrele disponibile bazate pe rezultate.",
    filterByMaterie: "Filtrează după Materie",
    fromResults: "Din rezultate",
    chooseObject: "Alege Obiectul",
    availableObjects: "Obiecte disponibile",
    objectLabel: "Obiect",
    objectsSelected: "obiecte selectate",
    objectsSelectedCount: "{count} obiecte selectate",
    modifyObject: "Modifică obiectul",
    filterByDetails: "Filtrează după Detalii",
    caseType: "Tip Speță",
    party: "Parte",
    legalPerspectives: "Perspective Juridice",
    methodologyManual: "Manual de Metodologie",
    methodologyManualDesc: "Abordare unitară în soluționarea cauzelor",
    argumentsAndAnalysis: "Argumente și Analize",
    legalAssistance: "Asistență Juridică",
    requestLegalHelp: "Solicită ajutor juridic",
    contact: "Contact",
    sendMessage: "Trimiteți-ne un mesaj",
    cancel: "Anulează",
    applyFilters: "Aplică Filtre",
    close: "Închide",
    hideFilters: "Ascunde filtre",
    showFilters: "Arată filtre",
    searchPlaceholder: "Caută...",
    noResults: "Nu s-au găsit rezultate"
  },
  en: {
    filters: "Filters",
    clearAll: "Clear All",
    noFiltersAvailable: "Perform a search to see available filters based on results.",
    filterByMaterie: "Filter by Legal Field",
    fromResults: "From results",
    chooseObject: "Choose Subject Matter",
    availableObjects: "Available subject matters",
    objectLabel: "Subject Matter",
    objectsSelected: "subject matters selected",
    objectsSelectedCount: "{count} subject matters selected",
    modifyObject: "Modify subject matter",
    filterByDetails: "Filter by Details",
    caseType: "Case Type",
    party: "Party",
    legalPerspectives: "Legal Perspectives",
    methodologyManual: "Methodology Manual",
    methodologyManualDesc: "Unified approach in case resolution",
    argumentsAndAnalysis: "Arguments & Analysis",
    legalAssistance: "Legal Assistance",
    requestLegalHelp: "Request legal assistance",
    contact: "Contact",
    sendMessage: "Send us a message",
    cancel: "Cancel",
    applyFilters: "Apply Filters",
    close: "Close",
    hideFilters: "Hide filters",
    showFilters: "Show filters",
    searchPlaceholder: "Search...",
    noResults: "No results found"
  },
  fr: {
    filters: "Filtres",
    clearAll: "Tout effacer",
    noFiltersAvailable: "Effectuez une recherche pour voir les filtres disponibles basés sur les résultats.",
    filterByMaterie: "Filtrer par Matière",
    fromResults: "Depuis les résultats",
    chooseObject: "Choisir l'Objet",
    availableObjects: "Objets disponibles",
    objectLabel: "Objet",
    objectsSelected: "objets sélectionnés",
    objectsSelectedCount: "{count} objets sélectionnés",
    modifyObject: "Modifier l'objet",
    filterByDetails: "Filtrer par Détails",
    caseType: "Type de litige",
    party: "Partie",
    legalPerspectives: "Perspectives Juridiques",
    methodologyManual: "Manuel de Méthodologie",
    methodologyManualDesc: "Approche unifiée dans la résolution des cas",
    argumentsAndAnalysis: "Arguments & Analyses",
    legalAssistance: "Assistance Juridique",
    requestLegalHelp: "Demander de l'aide juridique",
    contact: "Contact",
    sendMessage: "Envoyez-nous un message",
    cancel: "Annuler",
    applyFilters: "Appliquer les Filtres",
    close: "Fermer",
    hideFilters: "Masquer les filtres",
    showFilters: "Afficher les filtres",
    searchPlaceholder: "Rechercher...",
    noResults: "Aucun résultat trouvé"
  }
};

export default sidebarTranslations;
